import { apiClient } from '../../config/axios-client'
import type { QueueActivity, QueueActivityDetails } from '../../shared/models/QueueActivity'

export const queueApi = {
  list: (skip: number, top: number, filter?: Record<string, unknown>) =>
    apiClient.get<QueueActivity[]>('queued-activities', {
      params: { skip, top, ...filter },
    }),

  count: (filter?: Record<string, unknown>) =>
    apiClient.get<number>('queued-activities/count', {
      params: { ...filter },
    }),

  detail: (id: string) => apiClient.get<QueueActivityDetails>(`queued-activities/${id}`),

  delete: (id: string) => apiClient.delete<unknown>(`queued-activities/${id}`),

  cancel: (activityId: string) =>
    apiClient.post<unknown>(`queued-activities/cancel`, undefined, { params: { activityId } }),
}
